// piglia i famosi filters di graphQLmmerda e traduci in emmett REST

import { Filter } from '@/types/graphql-generated-types'
import { SortOptions } from '@/types/sort'

const rangeFields = {
  byArea: 'administrative_area_net',
  byBathrooms: 'property_rooms_bath',
  byBedrooms: 'property_rooms_bed',
  byPrice: 'pricing_sell_value',
  byRooms: 'property_rooms_all',
}
const intTodateFields = {
  byConstructionYear: 'property_date_construction',
}
const setFields = {
  byFloor: 'property_floor_position',
  byHeatingSystem: 'property_system_heating',
  byResidentialType: 'property_type',
  byStateAtDeed: 'administrative_state_deed',
  byStateOfMaintenance: 'property_state_maintenance',
}
const eqFields = {
  onlyWithBalcony: 'property_feature_balcony',
  onlyWithBasement: 'property_feature_basement',
  onlyWithBox: 'property_feature_box',
  onlyWithConciergeService: 'property_feature_concierge',
  onlyWithElevator: 'property_feature_elevator',
  onlyWithGarden: 'property_feature_garden',
  onlyWithParking: 'property_feature_parking',
  onlyWithPool: 'property_feature_pool',
  onlyWithTerrace: 'property_feature_terrace',
}
const floorEnumMap = {
  BASEMENT: 'basement',
  GROUND_FLOOR: 'ground',
  LAST_FLOOR: 'last',
  MID_FLOOR: 'mid',
}
const heatingEnumMap = {
  AUTONOMOUS: 'independent',
  NONE: 'none',
  SHARED: 'central',
}
const typeEnumMap = {
  APARTMENT: 'apartment',
  ATTIC: 'attic',
  HOUSE: 'house',
  LOFT: 'loft',
  MANSARD: 'mansard',
  TOWNHOUSE: 'townhouse',
  VILLA: 'villa',
}
const deedEnumMap = {
  FREE: 'free',
  OCCUPIED: 'occupied',
}
const maintenanceEnumMap = {
  HABITABLE: 'habitable',
  NEED_RENOVATION: 'need_renovation',
  NEW: 'new',
  RENOVATED: 'renovated',
  UNDER_CONSTRUCTION: 'construction',
}
const enumMaps = {
  byFloor: floorEnumMap,
  byHeatingSystem: heatingEnumMap,
  byResidentialType: typeEnumMap,
  byStateAtDeed: deedEnumMap,
  byStateOfMaintenance: maintenanceEnumMap,
}

// TODO: remove geoFilter as undefined once fixed `listingMap/index.test.tsx`
export function legacyGeoFilterToNikaFilter(geoFilter: string | string[] | undefined, target: Record<string, unknown>) {
  if (!geoFilter) return target
  if (geoFilter.length === 0) return target
  const geoFilterArray = Array.isArray(geoFilter) ? geoFilter : [geoFilter]

  const cities = geoFilterArray.filter((x) => x.split('/').length === 2)
  const zones = geoFilterArray.filter((x) => x.split('/').length === 3)

  if (cities.length > 0 && zones.length > 0) {
    return {
      ...target,
      $or: [{ geo_city: { $in: cities } }, { geo_zone: { $in: zones } }],
    }
  }
  return {
    ...target,
    ...(cities.length > 0 ? { geo_city: { $in: cities } } : {}),
    ...(zones.length > 0 ? { geo_zone: { $in: zones } } : {}),
  }
}

export const rangeFilterFieldMapper = (filter: Filter) => {
  return Object.keys(rangeFields).reduce((acc, legacyKey) => {
    if (!filter[legacyKey]) return acc
    return {
      ...acc,
      [rangeFields[legacyKey]]: {
        ...(filter[legacyKey].from ? { $gte: filter[legacyKey].from } : {}),
        ...(filter[legacyKey].to ? { $lte: filter[legacyKey].to } : {}),
      },
    }
  }, {})
}

export const intToDateFilterFieldMapper = (filter: Filter) => {
  return Object.keys(intTodateFields).reduce((acc, legacyKey) => {
    if (!filter[legacyKey]) return acc
    return {
      ...acc,
      [intTodateFields[legacyKey]]: {
        ...(filter[legacyKey].from ? { $gte: `${filter[legacyKey].from}-01-01T00:00:00Z` } : {}),
        ...(filter[legacyKey].to ? { $lte: `${filter[legacyKey].to}-12-31T23:59:59Z` } : {}),
      },
    }
  }, {})
}
export function legacyFiltersToNikaFilters(filter: Filter) {
  let nikaFilters = {
    ...rangeFilterFieldMapper(filter),
    ...intToDateFilterFieldMapper(filter),
  }

  for (const legacyKey of Object.keys(setFields)) {
    if (filter[legacyKey]) {
      let remapEnum = enumMaps[legacyKey]
      if (remapEnum !== undefined) {
        let values = []
        for (const value of filter[legacyKey] || []) {
          let mappedValue = remapEnum[value]
          if (mappedValue !== undefined) {
            values.push(mappedValue)
          }
        }
        if (values) {
          nikaFilters[setFields[legacyKey]] = {
            $in: values,
          }
        }
      } else {
        nikaFilters[setFields[legacyKey]] = {
          $in: filter[legacyKey],
        }
      }
    }
  }
  for (const legacyKey of Object.keys(eqFields)) {
    if (filter[legacyKey] || filter[legacyKey] === 0) {
      nikaFilters[eqFields[legacyKey]] = filter[legacyKey]
    }
  }
  nikaFilters = legacyGeoFilterToNikaFilter(filter.byGeoSlug, nikaFilters)

  // FIXME: check the proper combo
  if (filter.onlyCasavo === true) {
    nikaFilters['inventory'] = { $ne: null }
  }

  if (filter.onlyWithCoolingSystem === true) {
    nikaFilters['property_system_cooling'] = { $in: ['central', 'independent', 'ready'] }
  }

  return nikaFilters
}

const sortingMap = {
  AREA: 'administrative_area_net',
  DATE: 'created_at',
  PRICE: 'pricing_sell_value',
  RANKING: 'ranking',
}

export function legacySortingToNikaSorting(sort: SortOptions) {
  let mapped = sortingMap[sort.by]
  if (sort.direction === 'DESC') {
    mapped = `-${mapped}`
  }
  return mapped.split(',')
}
